import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormularioDialogService } from '../../../../../../auxiliares/servicios/formulario-dialog.service';
import { IPermiso } from 'modelos/src';
import {
  IAlcancePermiso,
  PermisoAlcanceService,
} from '../../../../../../auxiliares/servicios/permiso-alcance.service';
import { ClienteJerarquiaService } from '../../../../../../auxiliares/servicios/cliente-jerarquia.service';
import { PermisosEfectivosDialogComponent } from '../permisos-efectivos-dialog/permisos-efectivos-dialog.component';
import { modulosHabilitados } from '../../../../../../auxiliares/iconos/iconos';

export interface IDetallePermisoData {
  permiso: IPermiso;
}

// Detalle de un permiso del listado: alcance (incluido de qué entidades es
// cuando el nivel es Entidad), roles, módulos, vigencia y credenciales.
@Component({
  selector: 'app-detalle-permiso-dialog',
  templateUrl: './detalle-permiso-dialog.component.html',
  styleUrl: './detalle-permiso-dialog.component.scss',
  standalone: false,
})
export class DetallePermisoDialogComponent implements OnInit {
  public data = inject<IDetallePermisoData>(MAT_DIALOG_DATA);
  private alcanceService = inject(PermisoAlcanceService);
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private formularios = inject(FormularioDialogService);
  private dialogRef = inject(MatDialogRef<DetallePermisoDialogComponent>);

  public alcance?: IAlcancePermiso;
  public modulos: { nombre: string; icon: string }[] = [];

  get permiso(): IPermiso {
    return this.data.permiso;
  }

  get nombreUsuario(): string {
    return this.permiso.usuario?.usuario || this.permiso.nombreUsuario || '';
  }

  get nombrePersona(): string | undefined {
    return this.permiso.usuario?.datosPersonales?.nombre;
  }

  get tooltipJerarquia(): string {
    return this.clienteJerarquia.tooltipJerarquia(this.permiso.cliente) || '';
  }

  public async ngOnInit(): Promise<void> {
    await this.alcanceService.precargar([this.permiso]);
    this.alcance = this.alcanceService.alcance(this.permiso);
    this.modulos = this.getModulosHabilitados(this.permiso.modulos);
  }

  public cerrar(): void {
    this.dialogRef.close();
  }

  public verAccionesEfectivas(): void {
    this.formularios.abrir(PermisosEfectivosDialogComponent, {
      tamano: 'mediano',
      data: { permiso: this.permiso, usuario: this.nombreUsuario },
      cerrarAfuera: true,
    });
  }

  public getModulosHabilitados(
    modulos: any,
  ): { nombre: string; icon: string }[] {
    return modulosHabilitados(modulos);
  }
}
